import React, { useState, useEffect } from 'react';
import { Upload } from 'antd';
import { MediaHelpers } from '@wajeez-web/core/api';
import InputLabel from './InputLabel';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import { useTranslation } from 'react-i18next';

interface UploadFile {
  uid: string;
  name: string;
  status: 'error' | 'success' | 'done' | 'uploading' | 'removed';
  url: string;
  percent?: number;
  thumbUrl?: string;
}

interface UploadImgInputProps {
  name: string;
  required?: boolean;
  label?: string;
  disabled?: boolean;
  action: (name: string, value: string | undefined) => void;
  value?: string | null;
}

const UploadImgeInput = ({
  name,
  required,
  label,
  action,
  value = '',
  disabled = false,
}: UploadImgInputProps) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { t } = useTranslation();

  useEffect(() => {
    if (value) {
      MediaHelpers.getPublicMediaByIdAsync(value)
        .then((res) => {
          setFileList([
            {
              uid: name,
              name: name,
              status: 'done',
              url: res,
            },
          ]);
        })
        .catch(() => {
          setFileList([
            {
              uid: name,
              name: name,
              status: 'error',
              url: '',
            },
          ]);
        });
    }
  }, [value]);

  const onChange = ({ fileList: newFileList }: any) => {
    setFileList(newFileList);
  };

  const onPreview = async (file: any) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <div
      className={`flex flex-col justify-center rtl:items-start ltr:items-end  `}
    >
      <div>
        {label && (
          <InputLabel text={label} name={name || ''} required={required} />
        )}
      </div>
      {/* <ImgCrop rotate> */}
      <div>
        <Upload
          disabled={disabled}
          accept="image/*"
          action={(file: any) => {
            const formData = new FormData();

            formData.append('data', file as Blob);
            formData.append('fileNamets', name);
            return MediaHelpers.uploadMedia({
              fileName: name,
              data: file,
            }).then((res) => {
              res && action(name, res);
              return res || '';
            });
          }}
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
          onRemove={(file: any) => {
            action(name, undefined);
          }}
          className="input"
        >
          {fileList.length < 1 &&
            t(`inputs.labels.${'Upload +'}`, '').toString()}
        </Upload>
      </div>
      {/* </ImgCrop> */}
    </div>
  );
};

export default UploadImgeInput;
